import styled from "@emotion/styled";

export const CanOutputContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: 15px;
`;
